import { PurchaseAddressDto } from 'services/order/orderService.dto';
import { shipmentService } from 'services/shipment/shipmentService';
import { UserShippingAddressDto } from 'services/user/userService.dto';

export const MAX_TOTAL_NAME_LENGTH = 35;
export const MAX_SINGLE_NAME_LENGTH = 34;
export const MIN_PHONE_NUMBER_LENGTH = 11;
export const MAX_PHONE_NUMBER_LENGTH = 15;
export const MIN_POSTAL_CODE_LENGTH = 5;
export const MAX_POSTAL_CODE_LENGTH = 6;
export const MAX_ADDRESS_LENGTH = 35;
export const MAX_CITY_LENGTH = 30;

export const fetchCoordinates = async (postCode: string) => {
  if (postCode.length < MIN_POSTAL_CODE_LENGTH || postCode.length > MAX_POSTAL_CODE_LENGTH) return undefined;
  try {
    const { data } = await shipmentService.fetchGeocoding(postCode);
    return data.coordinates;
  } catch (e) {
    return undefined;
  }
};

export const checkAddressAlreadyExists = (
  address: UserShippingAddressDto,
  shippingAddresses: UserShippingAddressDto[]
) => {
  const shippingAddressesLowerCased = shippingAddresses.map(o => lowerCaseAddress(o));
  return shippingAddressesLowerCased.some(elem => {
    return JSON.stringify(elem) === JSON.stringify(lowerCaseAddress(address));
  });
};

const lowerCaseAddress = (address: UserShippingAddressDto) => {
  return {
    mobilePhone: {
      number: address.mobilePhone.number,
      areaCode: address.mobilePhone.areaCode,
      countryCode: address.mobilePhone.countryCode,
    },
    addressLine1: address.addressLine1.trim().toLowerCase(),
    addressLine2: address.addressLine2 ? address.addressLine2.trim().toLowerCase() : '',
    city: address.city.trim().toLowerCase(),
    postCode: address.postCode.trim().toLowerCase(),
    state: address.state.trim().toLowerCase(),
    firstName: address.firstName.trim().toLowerCase(),
    lastName: address.lastName.trim().toLowerCase(),
  } as UserShippingAddressDto;
};

export const areAddressesEqual = (shippingAddress: UserShippingAddressDto, orderAddress?: PurchaseAddressDto) => {
  if (!orderAddress) return false;
  return (
    shippingAddress.firstName === orderAddress.firstName &&
    shippingAddress.lastName === orderAddress.lastName &&
    shippingAddress.postCode === orderAddress.zip &&
    shippingAddress.city === orderAddress.city &&
    shippingAddress.addressLine1 === orderAddress.addressLine1 &&
    shippingAddress.addressLine2 === orderAddress.addressLine2 &&
    shippingAddress.state === orderAddress.state &&
    shippingAddress.mobilePhone.areaCode === orderAddress.mobilePhone.areaCode &&
    shippingAddress.mobilePhone.countryCode === orderAddress.mobilePhone.countryCode &&
    shippingAddress.mobilePhone.number === orderAddress.mobilePhone.number
  );
};
